import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { map } from 'rxjs/operators'
import * as fromRoot from '../../reducers'

export const sessionTokenGuard = () => {
  const store = inject(Store<fromRoot.State>)
  const router = inject(Router)

  return store.select(fromRoot.getAccessTokenState).pipe(
    map(oauth => {
      const hasSessionToken = !!oauth?.session_token

      if (!hasSessionToken) {
        router.navigate(['/sign-in'])
        return false
      }

      return true
    })
  )
}
